import { render, staticRenderFns } from "./launch-menu-help.vue?vue&type=template&id=c3ae9e4a&"
import script from "./launch-menu-help.vue?vue&type=script&lang=ts&"
export * from "./launch-menu-help.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports